export * from './time.pipe';
export * from './phone-number.pipe';
export * from './price.pipe';
